/**
 * MISA Notification In-App v2 — file tích hợp duy nhất
 * Kiểm soát toàn bộ lifecycle: init, destroy, feature flag
 */

function isEnabled() {
	const config = window.__env && window.__env.misaNotifyConfigV2;
	return config && config.enabled === true;
}

function setup(options) {
	MISA_Notification.init({
		token: options.getToken,
		onTokenInvalid: function(continueFn) {
			options
				.getToken(true)
				.then(function(newToken) {
					continueFn(newToken);
				})
				.catch(function() {
					options.onAuthError();
				});
		},
		language: 'vi'
	});

	if (options.inApp) {
		options.inApp();
	}

}

export function initMisaNotification(options) {
	if (!isEnabled()) return;

	if (window.MISA_Notification) {
		setup(options);
	} else {
		document.addEventListener(
			'MISANotificationLibReady',
			function() {
				setup(options);
			},
			{ once: true }
		);
	}
}

export function destroyMisaNotification() {
	if (window.MISA_Notification && window.MISA_Notification.inApp) {
		window.MISA_Notification.inApp.disconnect();
	}
}
